module.exports = __webpack_public_path__ + "static/media/cps.ab68c241.webp";